<button class="btn btn-primary btn-sm" class="{{btnClasses}}" [ngClass]="{'active': isActive}" [disabled]="disabled" (click)="clickEvent.emit()">
  <i class="{{iconClasses}}"></i>
  {{text | translate}}
</button>
